import { http } from "./http.js";

async function getNewRequest() {
  const response = await http.get("shipment-requests/new");
  return response;
}

async function getRequestDraft(id) {
  const response = await http.get(`shipment-request-drafts/${id}`);
  return response;
}

async function createNewRequest(entity) {
  const response = await http.post("/shipment-requests", entity);
  return response;
}

async function updateNewDraft(id, entity) {
  const response = await http.put(`shipment-request-drafts/${id}`, entity);
  return response;
}

async function createNewDraft(entity) {
  const response = await http.post("shipment-request-drafts", entity);
  return response;
}

async function deleteDraft(id) {
  const response = await http.delete(`shipment-request-drafts/${id}`);
  return response;
}

async function saveNewClientAlias(id, newClientAlias) {
  const response = await http.patch(`clients/${id}/aliases`, {
    value: newClientAlias,
  });
  return response;
}

async function getShipmentRequest(id) {
  const response = await http.get(`shipment-requests/${id}`);
  return response;
}

async function downloadOutputForm(id) {
  const response = await http.get(`shipment-requests/${id}/output-xlsx`, {
    responseType: "arraybuffer",
  });
  return response;
}

async function handleShipmentChangeWithNotification(id, notificationChange) {
  const response = await http.post(`/shipment-requests/${id}/messages`, {
    text: notificationChange,
  });
  return response;
}

async function getProposalsRequests(id) {
  const response = await http.get(`/shipment-requests/${id}/proposals`);
  return response.data.map(p => {
    return {
      id: p.Id,
      title: p.Title,
      version: p.Version ? p.Version.Title : "Тек. версия",
      date: p.CreatedAt,
      author: p.Author ? {
        id: p.Author.Id,
        title: p.Author.Title,
      } : null,
      text: p.Text,
    };
  });
}

async function getRequestNotes(id) {
  const response = await http.get(`/shipment-requests/${id}/notes`);
  return response.data.map(n => {
    return {
      id: n.Id,
      text: n.Text,
      date: n.CreatedAt,
      author: n.Author,
    };
  });
}

async function getProcessedVariants(id) {
  const response = await http.get(
    `/shipment-requests/${id}/processed-variants`,
  );
  return response.data.map(a => {
    return {
      id: a.Id,
      title: a.Title,
      content: a.Content,
    };
  });
}

async function getRequestMessages(id) {
  const response = await http.get(`/shipment-requests/${id}/messages`);
  return response.data.map(n => {
    return {
      id: n.Id,
      text: n.Text,
      date: n.CreatedAt,
      author: n.Author,
    };
  });
}

async function changeRequestState(id, state) {
  const response = await http.patch(`/shipment-requests/${id}/states`, {
    value: state,
  });
  return response;
}

async function getCurrentVersion(id, version) {
  const response = await http.get(
    `shipment-requests/${id}/versions/${version}`,
  );
  return response.data;
}

async function createMessage(id, message) {
  const response = await http.post(`/shipment-requests/${id}/messages`, {
    text: message,
  });
  return response;
}

async function createNote(id, note) {
  const response = await http.post(`/shipment-requests/${id}/notes`, {
    text: note,
  });
  return response;
}

async function deleteProcessedVariant(id, variantId) {
  const response = await http.delete(
    `/shipment-requests/${id}/processed-variants/${variantId}`,
  );
  return response;
}

async function updateProcessedVariant(id, variantId, title, content) {
  const response = await http.put(
    `/shipment-requests/${id}/processed-variants/${variantId}`,
    {
      title,
      content,
    },
  );
  return response;
}

async function createProcessedVariant(id, title, content) {
  const response = await http.post(
    `/shipment-requests/${id}/processed-variants/`,
    {
      title,
      content,
    },
  );
  return response;
}

async function updateProposal(id, editProposalId, proposal) {
  const response = await http.put(
    `/shipment-requests/${id}/proposals/${editProposalId}`,
    {
      text: proposal,
    },
  );
  return response;
}

async function createProposal(id, proposal) {
  const response = await http.post(`/shipment-requests/${id}/proposals`, {
    text: proposal,
  });
  return response;
}

async function getSameRegionRequest(id) {
  const response = await http.get(
    `shipment-requests/${id}/same-region-requests`,
  );
  return response.data.map(r => {
    return {
      id: r.Id,
      title: r.Title,
    };
  });
}

async function getHistory(id) {
  const response = await http.get(`shipment-requests/${id}/states-history`);
  return response.data.map(h => {
    return {
      id: h.Id,
      createdAt: h.CreatedAt,
      author: h.Author.Title,
      state: h.State.Title,
    };
  });
}

export {
  getNewRequest,
  getRequestDraft,
  createNewRequest,
  updateNewDraft,
  createNewDraft,
  deleteDraft,
  saveNewClientAlias,
  getShipmentRequest,
  downloadOutputForm,
  handleShipmentChangeWithNotification,
  getProposalsRequests,
  getRequestNotes,
  getProcessedVariants,
  getRequestMessages,
  changeRequestState,
  getCurrentVersion,
  createMessage,
  createNote,
  deleteProcessedVariant,
  updateProcessedVariant,
  createProcessedVariant,
  updateProposal,
  createProposal,
  getSameRegionRequest,
  getHistory,
};
